import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f3279a0&scoped=true&"
import script from "./index.js?vue&type=script&lang=ts&"
export * from "./index.js?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=3f3279a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3279a0",
  null
  
)

export default component.exports